/* Custom JavaScript for cart modifications */

// Clear Cart functionality
function clearCart() {
  if (!confirm('Are you sure you want to clear your entire cart?')) {
    return;
  }

  // Show loading state
  const clearButtons = document.querySelectorAll('.wt-cart__clear-button');
  clearButtons.forEach(btn => {
    btn.disabled = true;
    btn.textContent = 'Clearing...';
  });

  // Use Shopify Cart API to clear cart
  fetch('/cart/clear.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then(response => response.json())
    .then(data => {
      // Reload the page to show empty cart
      window.location.reload();
    })
    .catch(error => {
      console.error('Error clearing cart:', error);
      alert('There was an error clearing your cart. Please try again.');
      clearButtons.forEach(btn => {
        btn.disabled = false;
        btn.textContent = 'Clear Cart';
      });
    });
}

// Initialize clear cart buttons when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initClearCartButtons);
} else {
  initClearCartButtons();
}

function initClearCartButtons() {
  const clearButtons = document.querySelectorAll('.wt-cart__clear-button');
  clearButtons.forEach(button => {
    button.addEventListener('click', clearCart);
  });
}

